import { Record as ImmutableRecord, List } from 'immutable';
export default class Timezone extends ImmutableRecord({
  offset: '',
  name: '',
  momentTimezones: List()
}) {
  identifier() {
    return this.momentTimezones.first();
  }
}